import { render, staticRenderFns } from "./FormProductInput.vue?vue&type=template&id=2651eb62&scoped=true"
import script from "./FormProductInput.vue?vue&type=script&lang=js"
export * from "./FormProductInput.vue?vue&type=script&lang=js"
import style0 from "./FormProductInput.vue?vue&type=style&index=0&id=2651eb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651eb62",
  null
  
)

export default component.exports